module.exports = __webpack_public_path__ + "static/media/preview.ffd636c7.png";